module.exports = __webpack_public_path__ + "static/media/instaPot.a1ee5cc1.jpg";